import React from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { MANUAL_VOUCHER_PAYMENT_PATH } from '../../../../config/paths';

import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';

import ManualVoucherPaymentForm from './ManualVoucherPaymentForm';

import { postManualVoucherPayment } from '../../../../actions/corporate/ManualVoucherPayment';
import { tzNormalizeDate } from '../../../../utils/date';

const getId = (value) => {
  if (!value) {
    return null;
  }

  if (value.value !== undefined) {
    return value.value;
  }

  if (value.id !== undefined) {
    return value.id;
  }

  return value;
};

const NewManualVoucherPayment = ({
  breadcrumbs,
  dispatchPostManualVoucherPayment,
}) => {
  const onSubmit = (formValues) => {
    const { business, customer, isNaturalPerson, manualVoucherId, payments } =
      formValues;

    const businessId =
      manualVoucherId || isNaturalPerson ? null : getId(business);

    const customerId =
      manualVoucherId || !isNaturalPerson ? null : getId(customer);

    const newPayments = payments.map((payment) => ({
      bankAccountId: getId(payment.bankAccountId),
      operationNumber: payment.operationNumber,
      manualVoucherId: manualVoucherId || null,
      businessId,
      customerId,
      amount: payment.actualAmountDeposited,
      depositDate: tzNormalizeDate({
        date: payment.depositDate,
      }),
      approved: false,
    }));

    return dispatchPostManualVoucherPayment(newPayments);
  };

  const generateInitialValues = () => ({
    manualVoucherId: null,

    payments: [{}],
  });

  const content = (
    <ManualVoucherPaymentForm
      onSubmit={onSubmit}
      initialValues={generateInitialValues()}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Pago de Comprobante Manual"
      subtitle="Registrar pagos"
      content={content}
    />
  );
};

NewManualVoucherPayment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,

  dispatchPostManualVoucherPayment: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostManualVoucherPayment: postManualVoucherPayment,
};

const mapStateToProps = ({ CorporateUnit }) => ({
  breadcrumbs: [
    ...CorporateUnit.UnitHome.get('breadcrumbs'),

    {
      text: 'Lista de Pagos',
      href: MANUAL_VOUCHER_PAYMENT_PATH,
    },

    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewManualVoucherPayment);
